import React, { useState, useEffect } from "react";
import { useForm, ValidationError } from "@formspree/react";
import { motion } from "framer-motion";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiClock,
  FiSend,
  FiInstagram,
} from "react-icons/fi";

export const Contact = () => {
  const [state, handleSubmit] = useForm("mgvnolan");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (state.submitting) {
      setIsSubmitting(true);
    }

    if (state.succeeded) {
      setMessage(
        "Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız."
      );
      setIsSubmitting(false);
      setTimeout(() => setMessage(""), 5000);
    }

    if (state.errors) {
      setIsSubmitting(false);
    }
  }, [state.succeeded, state.submitting, state.errors]);

  const contactInfo = [
    {
      icon: FiPhone,
      title: "Telefon",
      content: "+90 505 551 77 47",
      href: "tel:+905055517747",
      color: "#3b82f6",
    },
    {
      icon: FiMail,
      title: "E-posta",
      content: "dilanaslan3009@gmail.com",
      href: "mailto:dilanaslan3009@gmail.com",
      color: "#10b981",
    },
    {
      icon: FiMapPin,
      title: "Adres",
      content: "Artuklu, Mardin / Türkiye",
      href: null,
      color: "#f59e0b",
    },
    {
      icon: FiClock,
      title: "Çalışma Saatleri",
      content: "Pzt - Pzr: 09:00 - 18:00",
      href: null,
      color: "#8b5cf6",
    },
  ];

  const inputStyle = {
    width: "100%",
    padding: "14px 18px",
    fontSize: "1rem",
    border: "2px solid #e2e8f0",
    borderRadius: "12px",
    outline: "none",
    transition: "all 0.2s ease",
    backgroundColor: "#f8fafc",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "0.95rem",
    fontWeight: "600",
    color: "#334155",
  };

  return (
    <section
      id="contact"
      style={{
        padding: "80px 0",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        {/* Başlık */}
        <motion.div
          style={{ textAlign: "center", marginBottom: "48px" }}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span
            style={{
              display: "inline-block",
              backgroundColor: "#dbeafe",
              color: "#1d4ed8",
              padding: "8px 20px",
              borderRadius: "50px",
              fontSize: "0.9rem",
              fontWeight: "600",
              marginBottom: "12px",
            }}
          >
            İLETİŞİM
          </span>
          <h2
            style={{
              fontSize: "2.5rem",
              fontWeight: "800",
              color: "#0f172a",
              marginBottom: "12px",
            }}
          >
            Bize Ulaşın
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              color: "#64748b",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            Sorularınız için bizimle iletişime geçin, en kısa sürede dönüş
            yapalım
          </p>
        </motion.div>

        {/* Ana İçerik */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 400px",
            gap: "32px",
            alignItems: "start",
          }}
        >
          {/* Sol - Form */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            style={{
              backgroundColor: "white",
              borderRadius: "24px",
              padding: "36px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
              border: "1px solid #f1f5f9",
            }}
          >
            {/* Başarı Mesajı */}
            {message && (
              <motion.div
                style={{
                  backgroundColor: "#dcfce7",
                  color: "#166534",
                  padding: "16px 20px",
                  borderRadius: "12px",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  fontSize: "0.95rem",
                  fontWeight: "500",
                }}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
              >
                <span style={{ fontSize: "1.25rem" }}>✓</span>
                {message}
              </motion.div>
            )}

            <form onSubmit={handleSubmit}>
              {/* İsim ve Email */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <label htmlFor="name" style={labelStyle}>
                    İsim Soyisim *
                  </label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Adınız ve soyadınız"
                    required
                    disabled={state.submitting}
                    style={inputStyle}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#3b82f6";
                      e.target.style.backgroundColor = "#ffffff";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e2e8f0";
                      e.target.style.backgroundColor = "#f8fafc";
                    }}
                  />
                  <ValidationError
                    prefix="Name"
                    field="name"
                    errors={state.errors}
                  />
                </div>
                <div>
                  <label htmlFor="email" style={labelStyle}>
                    E-posta Adresi *
                  </label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="ornek@email.com"
                    required
                    disabled={state.submitting}
                    style={inputStyle}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#3b82f6";
                      e.target.style.backgroundColor = "#ffffff";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e2e8f0";
                      e.target.style.backgroundColor = "#f8fafc";
                    }}
                  />
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>
              </div>

              {/* Telefon */}
              <div style={{ marginBottom: "20px" }}>
                <label htmlFor="phone" style={labelStyle}>
                  Telefon
                </label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder="05XX XXX XX XX"
                  disabled={state.submitting}
                  style={inputStyle}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#3b82f6";
                    e.target.style.backgroundColor = "#ffffff";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.backgroundColor = "#f8fafc";
                  }}
                />
              </div>

              {/* Konu */}
              <div style={{ marginBottom: "20px" }}>
                <label htmlFor="subject" style={labelStyle}>
                  Konu
                </label>
                <input
                  id="subject"
                  type="text"
                  name="subject"
                  placeholder="Mesaj konusu"
                  disabled={state.submitting}
                  style={inputStyle}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#3b82f6";
                    e.target.style.backgroundColor = "#ffffff";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.backgroundColor = "#f8fafc";
                  }}
                />
              </div>

              {/* Mesaj */}
              <div style={{ marginBottom: "24px" }}>
                <label htmlFor="message" style={labelStyle}>
                  Mesajınız *
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Mesajınızı buraya yazın..."
                  rows="5"
                  required
                  disabled={state.submitting}
                  style={{
                    ...inputStyle,
                    resize: "vertical",
                    minHeight: "140px",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#3b82f6";
                    e.target.style.backgroundColor = "#ffffff";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = "#e2e8f0";
                    e.target.style.backgroundColor = "#f8fafc";
                  }}
                />
                <ValidationError
                  prefix="Message"
                  field="message"
                  errors={state.errors}
                />
              </div>

              {/* Gönder Butonu */}
              <button
                type="submit"
                disabled={state.submitting}
                style={{
                  width: "100%",
                  padding: "16px 32px",
                  fontSize: "1rem",
                  fontWeight: "600",
                  color: "white",
                  backgroundColor: state.submitting ? "#94a3b8" : "#2563eb",
                  border: "none",
                  borderRadius: "12px",
                  cursor: state.submitting ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  transition: "all 0.2s ease",
                }}
              >
                {isSubmitting ? (
                  <>
                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid white",
                        borderTopColor: "transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <FiSend size={18} />
                    Mesajı Gönder
                  </>
                )}
              </button>
            </form>
          </motion.div>

          {/* Sağ - İletişim Bilgileri */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {/* İletişim Kartları */}
            {contactInfo.map((info, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "white",
                  borderRadius: "16px",
                  padding: "20px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                  border: "1px solid #f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  transition: "all 0.2s ease",
                  cursor: info.href ? "pointer" : "default",
                }}
                onClick={() => info.href && window.open(info.href, "_self")}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "12px",
                    backgroundColor: `${info.color}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <info.icon size={22} color={info.color} />
                </div>
                <div>
                  <p
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      margin: "0 0 4px 0",
                    }}
                  >
                    {info.title}
                  </p>
                  <p
                    style={{
                      fontSize: "1rem",
                      fontWeight: "600",
                      color: "#0f172a",
                      margin: 0,
                    }}
                  >
                    {info.content}
                  </p>
                </div>
              </div>
            ))}

            {/* Sosyal Medya */}
            <div
              style={{
                backgroundColor:
                  "linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)",
                background: "linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)",
                borderRadius: "16px",
                padding: "24px",
                marginTop: "8px",
              }}
            >
              <p
                style={{
                  color: "white",
                  fontWeight: "600",
                  marginBottom: "16px",
                  fontSize: "1rem",
                }}
              >
                Sosyal Medyada Bizi Takip Edin
              </p>
              <a
                href="https://www.instagram.com/cg.dilanaslan/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "rgba(255,255,255,0.1)",
                  color: "white",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  fontWeight: "500",
                  transition: "all 0.2s ease",
                }}
              >
                <FiInstagram size={20} />
                @cg.dilanaslan
              </a>
            </div>

            {/* Harita veya Ek Bilgi */}
            <div
              style={{
                backgroundColor: "#f0f9ff",
                borderRadius: "16px",
                padding: "20px",
                border: "1px solid #bae6fd",
              }}
            >
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#0369a1",
                  margin: 0,
                  lineHeight: "1.6",
                }}
              >
                💡 <strong>Hızlı Randevu:</strong> WhatsApp üzerinden de bize
                ulaşabilir, hızlıca randevu alabilirsiniz.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Spinner Animation */}
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          @media (max-width: 900px) {
            #contact > div > div:nth-child(2) {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Contact;
